import React from 'react';

import { theme } from '../../../../tailwind.config';
import { IIconProps } from 'ui/CircleIconButton';

export const InfoFilled: React.FC<IIconProps> = React.memo(({ width = 18, height = 18, icon = 'red-95' }) => (
  <svg width={width} height={height} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="9" cy="9" r="8.33333" fill={theme.colors[icon]} />
    <rect x="8.16663" y="4.83329" width="1.66667" height="1.66667" fill="white" />
    <rect x="8.16663" y="8.16663" width="1.66667" height="5" fill="white" />
  </svg>
));

export default InfoFilled;
